export const CLOSE_THREAD = 'CLOSE_THREAD';
export const FETCH_PROPERTIES_META = 'FETCH_PROPERTIES_META';
export const FETCH_PROPERTIES_FOR_THREAD = 'FETCH_PROPERTIES_FOR_THREAD';
export const MARK_THREAD_AS_GHOSTED = 'MARK_THREAD_AS_GHOSTED';
export const PATCH_PROPERTY_FOR_THREAD = 'PATCH_PROPERTY_FOR_THREAD';
export const RESOLVE_UPDATE_PROPERTY_ERROR = 'RESOLVE_UPDATE_PROPERTY_ERROR';